<template>
<div>
  <section class="content-header">
    <h1>
      语吧周度对比
      <small>学习数据</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/learnDetails/learnDetails">学习数据</a></li>
      <li class="active">语吧周度对比</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px" v-show="!printingPDF">
      <el-form :inline="true" :model="filters">
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型" @change="chOrgType">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
          <el-select v-model="filters.customer" filterable clearable placeholder="学校" style="width: 360px">
            <el-option
              v-for="item in modCustomers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <br>
        <el-form-item>
          课程类型:
          <el-select v-model="filters.featureId" filterable placeholder="课程类型">
            <el-option
              v-for="item in [{id:'6',name:'大声说英语'},{id:'9',name:'萌宠'},{id:'19',name:'宝宝说英语'}]"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          卡密类型:
          <el-select v-model="filters.cardType" filterable clearable placeholder="卡密类型">
            <el-option
              v-for="item in [{id:'all', name:'全部'},
                {id:'t4d365', name:'年卡'},
                {id:'d93', name:'季卡'},
                {id:'d62', name:'双月卡'},
                {id:'t3', name:'活动卡'},
                {id:'t1', name:'体验卡'},
                {id:'none', name:'无卡密'}
              ]"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
					<el-button type="primary" icon="el-icon-download" v-show="canPrint" @click="genPdf">生成PDF</el-button>
				</el-form-item>
			</el-form>
      <div class="duration">
        <span class="label">当前查询时间段：</span>
        <span class="value">{{dateRange[0]}} 至 {{dateRange[1]}}</span>
      </div>
    </el-card>

    <el-card class="title" v-show="printingPDF">
      <h3>{{modCustomers.find(e=>e.id===filters.customer) 
        && modCustomers.find(e=>e.id===filters.customer).name}}</h3>
      <h3>{{dateRange[0]}} ~ {{dateRange[1]}}</h3>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">线上出勤情况</span>
      </div>

      <div class="echart">
        <IEcharts :option="attendance" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <pre>
        合格人数：自然周内，出勤天数大于等于5天  的用户数
        总用户数：选定自然周内，有课程的用户数，包括在本周期内过期的用户数
        占比=合格人数 / 总用户数</pre>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">线上学习时长情况</span>
      </div>

      <div class="echart">
        <IEcharts :option="learnDuration" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <pre>
        合格人数：自然周内，线上学习时长大于等于50分钟  的用户数
        总用户数：选定自然周内，有课程的用户数，包括在本周期内过期的用户数
        占比=合格人数 / 总用户数</pre>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">星星获得情况</span>
      </div>

      <div class="echart">
        <IEcharts :option="star" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <pre>
        合格人数：自然周内，星星获得大于15颗  的用户数
        总用户数：选定自然周内，有课程的用户数，包括在本周期内过期的用户数
        占比=合格人数 / 总用户数</pre>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">巧口秀使用情况</span>
      </div>

      <div class="echart">
        <IEcharts :option="qoocoshow" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <pre>
        合格人数：自然周内，巧口秀上传视频数量非0  的用户数
        总用户数：选定自然周内，有课程的用户数，包括在本周期内过期的用户数
        占比=合格人数 / 总用户数</pre>
    </el-card>

  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import {mapGetters} from 'vuex'
import {loadClubWeeks} from 'api/learn-details'
import {getLastWeek, extractArrsFromObj} from 'common/js/app-utils'
import html2pdf from 'html2pdf.js'
import moment from 'moment'
// import {Loading} from 'element-ui'

var _ = require('lodash') // 深拷贝
var colors = ['rgb(91,155,213)', '#ef3e42']

export default {
  computed: {
    ...mapGetters([
      'orgTypes',
      'customers',
      'pickerOptions'
    ])
  },
  data () {
    return {
      modCustomers: [],
      canPrint: false,
      printingPDF: false,
      dateRange: [],
      currentDate: new Date(),
      filters: {
        customer: [],
        dateRange: [],
        orgType: '',
        featureId: '6',
        cardType: 'all'
      },

      loading: true,

      attendance: {},
      learnDuration: {},
      star: {},
      qoocoshow: {}
    }
  },
  components: {
    IEcharts
  },
  created () {
    [{k: 'attendance', v: '线上出勤', type: 'bar'},
    {k: 'learnDuration', v: '线上学习时长', type: 'bar'},
    {k: 'star', v: '星星数量', type: 'bar'},
    {k: 'qoocoshow', v: '巧口秀视频数量', type: 'bar'}
    ].forEach(obj => {
      // 创建柱形图------------------------------------------
      this[obj.k] = {
        title: {
          text: `${obj.v}`,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          formatter: param => {
            let o = param[0]
            let t = param[1]
            let u = param[2]
            return `${o.axisValue}<br/>
            ${o.marker + o.seriesName}: ${o.data}<br/>
            ${t.marker + t.seriesName}: ${t.data}<br/>
            ${u.marker + u.seriesName}: ${Number(u.data * 100).toFixed(0)}%`
          },
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {x: '15%', y: '14%', width: '70%', height: '70%'},
        legend: {
          data: [`合格人数`, `总用户数`, `占比`],
          bottom: 5
        },
        xAxis: {
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: `人数`,
            min: 0,
            position: 'left',
            axisLine: {
              lineStyle: {
                color: colors[0]
              }
            },
            axisLabel: {
              formatter: '{value} 人'
            }
          },
          {
            type: 'value',
            name: `占比`,
            min: 0,
            max: 1,
            position: 'right',
            axisLine: {
              lineStyle: {
                color: colors[1]
              }
            },
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: `合格人数`,
            type: 'bar',
            showAllSymbol: true,
            data: [],
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            }
          },
          {
            name: `总用户数`,
            type: 'bar',
            showAllSymbol: true,
            data: [],
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            }
          },
          {
            name: `占比`,
            type: 'line',
            showAllSymbol: true,
            yAxisIndex: 1,
            data: [],
            label: {
              normal: {
                show: true,
                position: 'top',
                color: 'black',
                formatter: (params) => {
                  return `${Number(params.value * 100).toFixed(0)}%`
                }
              }
            }
          }
        ],
        color: colors
      }
    })
  },
  mounted () {
    this.chOrgType()
    this.query()
  },
  methods: {
    query () {
      this._showDateRange(this._loadClubWeeks)
    },
    _showDateRange (callback) {
      let t = _.cloneDeep(this.filters.dateRange)
      console.log(t)
      if (t && t.length === 2) {
        this.dateRange = t
        callback()
      } else {
        this.dateRange = getLastWeek()
        callback()
      }
    },
    _loadClubWeeks () {
      this.canPrint = false
      this.loading = true
      let dateRange = this.dateRange
      console.log(dateRange)
      let m0 = moment(dateRange[0], 'YYYY-MM-DD')
      let m1 = moment(dateRange[1], 'YYYY-MM-DD')
      let mMax = moment(m0).add(7 * 5, 'days')
      let isIn7day = m1.format('YYYYMMDD') < mMax.format('YYYYMMDD')
      if (isIn7day) { // 一周以内的时间段
        loadClubWeeks(this.filters)
        .then(res => {
          console.log(res)
          this.canPrint = true
          this.loading = false
          ;['attendance', 'learnDuration', 'star', 'qoocoshow'].forEach(item => {
            // 填充柱状图（比例）
            console.log(res[item])
            let arrs = extractArrsFromObj(res[item], ['week', 'total', 'num', 'rate'])
            console.log(arrs)
            this[`${item}`].yAxis[0].max = Math.max.apply(null, arrs.total) // 总用户数
            this[`${item}`].xAxis.data = arrs.week.reverse()
            this[`${item}`].series[0].data = arrs.num.reverse()
            this[`${item}`].series[1].data = arrs.total.reverse()
            // 占比
            this[`${item}`].series[2].data = arrs.rate.reverse()
          })
        }, msg => {
          this.canPrint = false
          this.loading = false
          this._resetData()
          this.$message.error(msg)
        })
      } else {
        this.canPrint = false
        this.loading = false
        this._resetData()
        this.$message.error(`请选择5周以内的时间段！`)
      }
    },
    chOrgType () {
      if (this.filters.orgType === '' || this.filters.orgType === 'all') {
        this.modCustomers = this.customers
      } else {
        this.filters.customer = ''
        this.modCustomers = this.customers.filter(t => t.type === this.filters.orgType)
      }
    },
    _resetData () {
      ['attendance', 'learnDuration', 'star', 'qoocoshow'].forEach(item => {
        // 清空柱状图（比例）
        this[`${item}`].xAxis.data = []
        this[`${item}`].series[0].data = []
        this[`${item}`].series[1].data = []
      })
    },
    genPdf () {
      let _this = this
      let customer = _this.customers.filter(t => t.id === _this.filters.customer)[0]
      let filename = `${customer.name}(${_this.dateRange[0]}~${_this.dateRange[1]}).pdf`
      let dom2Print = document.querySelector('.content')
      let originWidth = dom2Print.style.width
      dom2Print.style.width = '800px'
      this.printingPDF = true
      setTimeout(() => {
        html2pdf().from(dom2Print).save(filename).then(() => {
          dom2Print.style.width = originWidth
          _this.printingPDF = false
        })
      }, 1000)
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
  .echart
    margin 30px 0
  .title
    text-align: center
</style>



// WEBPACK FOOTER //
// src/components/learn-details/learn-details-clubweeks.vue